import React, { useState, useEffect } from 'react';
// import Image from "../banner.jpg"
import axios from 'axios';
import { Audio, Oval } from  'react-loader-spinner';
import Pagination from "./Pagination";

function Movies() {
    const [movies, setMovies] = useState([]);
    const [pageNumber, setPageNumber] = useState(1);
    const [hover, setHover] = useState();
    const [favourites, setFavourites] = useState([]);


    function gotoNextPage(){
        setPageNumber(currPage => currPage+1);
      }
    
      function gotoPrevPage(){
        if(pageNumber>1){
          setPageNumber(currPage => currPage-1);
        }
      }

    useEffect(function(){
      //runs everytime when page reloads

      //naya data manga rahe hai
        axios.get(`https://api.themoviedb.org/3/trending/movie/week?api_key=ea1c463be08abb857662aa8bef37a004&page=${pageNumber}`)
        .then((res)=>{
            // console.log(res.data.results);
            setMovies(res.data.results);
        })

        //read favs from local storage
        let oldFav = localStorage.getItem("favourites");
        oldFav = JSON.parse(oldFav) || []; //if no favs in local storage, then empty array
        
        setFavourites([...oldFav]);

    },[pageNumber])

    let addToFav = (movie) => {
      //add both in state and local storage
      let newFav = [...favourites, movie];
      //set fav state
      setFavourites(newFav);
      // save to local storage
      localStorage.setItem('favourites', JSON.stringify(newFav));
    }

    let removeFromFav = (movie) => {
      //remove from both in state and local storage
      let newFav = favourites.filter(fav => fav.id !== movie.id);
      setFavourites(newFav);
      localStorage.setItem('favourites', JSON.stringify(newFav));
    }

  return(<>
        <div className='mb-8'>
            <div className='mt-8 mb-8 font-bold text-2xl text-center'>Trending Movies</div>
            {
                movies.length == 0 ? 
                    <div className='flex justify-center'>
                        <Oval
                        heigth="100"
                        width="100"
                        color='grey'
                        secondaryColor='gray'
                        ariaLabel='loading'
                        />
                    </div> :

                <div className='flex flex-wrap justify-center'>
                    {movies.map((movie)=>(
                        // card
                        <div className={`
                              bg-[url(${`http://image.tmdb.org/t/p/w500/${movie.poster_path}`})]
                              md:h-[30vh] md:w-[200px]
                              h-[25vh] w-[150px]
                              bg-center bg-cover
                              rounded-xl flex items-end m-4
                              hover:scale-110 text-xl font-bold
                              ease-out duration-300
                              relative
                          `}
                            onMouseEnter={()=>setHover(movie.id)}
                            onMouseLeave={()=>setHover(0)}
                          >
                            {
                              movie.id==hover && <>{
                                favourites.find(fav=>fav.id==movie.id) ?
                              <div className='absolute top-2 right-2 
                              p-2 bg-slate-50/[0.5] rounded-xl  cursor-pointer
                              ' 
                              onClick={()=>removeFromFav(movie)}>
                                ❌</div> :

                               <div className='absolute top-2 right-2 
                              p-2 bg-slate-50/[0.5] rounded-xl  cursor-pointer text-3xl
                              ' 
                              onClick={()=>addToFav(movie)}>
                               ❤️</div>

                              }
                              


                               </>
                              
                            }
                              <div className='w-full bg-gray-900 text-white py-2 text-center rounded-b-xl'>{movie.title}</div>
                        </div>
                      )
                    )}
            </div>   
}
        </div>
    <Pagination pageNumber={pageNumber} gotoNextPage={gotoNextPage} gotoPrevPage={gotoPrevPage}/>
  </>);
}
export default Movies;
